"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var zoom_button_html_1 = __importDefault(require("./zoom-button.html"));
require("./zoom-button.less");
(function (module) {
    'use strict';
    function ZoomButtonController(viewOptions) {
        var btnCtrl = this;
        angular.extend(btnCtrl, {
            getZoom: function () {
                return viewOptions.getZoomLabel();
            },
            getZoomMenu: function () {
                return viewOptions.getZoomItems();
            },
            change: function (zoom) {
                viewOptions.zoom(zoom);
            }
        });
    }
    ZoomButtonController.$inject = ['prViewOptions'];
    module.component('prZoomButton', {
        templateUrl: zoom_button_html_1.default,
        controller: ZoomButtonController
    });
}(angular.module('qualtrics.pr')));
